<div *ngIf="chargement" class="fluid formgrid grid">
  <div class="flex flex-column gap-2 col-12 text-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div *ngIf="!chargement && groupes.length === 0" class="flex flex-column align-items-center justify-content-center gap-2 p-4">
  <i class="pi pi-inbox text-4xl text-500"></i>
  <p class="text-500 m-0">Aucune évaluation pour cet emplacement.</p>
</div>

<div *ngIf="!chargement && groupes.length > 0" class="flex flex-column gap-4">
  <div class="flex justify-content-start mb-2">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [(ngModel)]="filtreFournisseur"
        placeholder="Filtrer par nom ou numéro..."
        class="w-full sm:w-auto"
      />
    </span>
  </div>
  <div *ngIf="groupesFiltres.length === 0" class="flex flex-column align-items-center justify-content-center gap-2 p-4">
    <i class="pi pi-filter-slash text-4xl text-500"></i>
    <p class="text-500 m-0">Aucun fournisseur ne correspond à la recherche.</p>
  </div>
  <div *ngFor="let groupe of groupesFiltres" class="flex flex-column gap-2">
    <p-card>
      <ng-template pTemplate="header">
        <div class="flex align-items-center justify-content-between flex-wrap gap-2 p-3 surface-section border-bottom">
          <h5 class="m-0 font-semibold">
            {{ groupe.nomFournisseur }} ({{ groupe.numeroFournisseur }})
          </h5>
          <div class="flex gap-1">
            <p-button
              pRipple
              icon="pi pi-star"
              label="Ajouter une évaluation"
              severity="success"
              (click)="evaluerFournisseur(groupe)"
            ></p-button>
            <p-button
              pRipple
              icon="pi pi-building"
              label="Voir le fournisseur"
              severity="secondary"
              (click)="voirFournisseur(groupe.fournisseurId)"
            ></p-button>
          </div>
        </div>
      </ng-template>
      <p-table
        [value]="groupe.evaluations"
        tableStyleClass="tableNormale"
        autoLayout="true"
        [rowHover]="true"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Date</th>
            <th>Produits/Services</th>
            <th>Qualité produit</th>
            <th>Qualité service</th>
            <th>Prix</th>
            <th>Travail sur site</th>
            <th>Méthodes de travail sécuritaire</th>
            <th>Évaluateur</th>
            <th style="width: 5rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-evaluation>
          <tr>
            <td>{{ evaluation.createdDate | date:'yyyy-MM-dd' }}</td>
            <td>{{ evaluation.productsServices }}</td>
            <td>
              <p-tag
                [severity]="getQualityScore(evaluation, 'product')"
                [value]="getQualityScoreLabel(evaluation, 'product')"
              ></p-tag>
            </td>
            <td>
              <p-tag
                [severity]="getQualityScore(evaluation, 'service')"
                [value]="getQualityScoreLabel(evaluation, 'service')"
              ></p-tag>
            </td>
            <td>
              <p-tag
                [severity]="getQualityScore(evaluation, 'pricing')"
                [value]="getQualityScoreLabel(evaluation, 'pricing')"
              ></p-tag>
            </td>
            <td>
              <p-tag
                [severity]="getQualityScore(evaluation, 'onsite')"
                [value]="getQualityScoreLabel(evaluation, 'onsite')"
              ></p-tag>
            </td>
            <td>
              <p-tag
                [severity]="getQualityScore(evaluation, 'safeWorkingPractices')"
                [value]="getQualityScoreLabel(evaluation, 'safeWorkingPractices')"
              ></p-tag>
            </td>
            <td>
              <app-employe-avec-emplacement [employe]="evaluation.employe"></app-employe-avec-emplacement>
            </td>
            <td>
              <div class="flex gap-1">
                <p-button
                  pRipple
                  icon="pi pi-eye"
                  severity="success"
                  (click)="afficherEvaluation(evaluation)"
                ></p-button>
                <p-button
                  pRipple
                  icon="pi pi-building"
                  severity="secondary"
                  (click)="voirFournisseur(groupe.fournisseurId)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9">Aucune évaluation.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
